/**
 * The extension definition entity (`ActivityEntityName.Agent`): agents, workflows and code automations. Only a workflow has a
 * surface operation: Edit opens the workflow editor in the shell's dialog outlet as a pseudo-page, so its URL survives a
 * refresh and can be shared (`/settings/extension-runtime(dialog:agent/edit;id=…)`). Agents keep their settings-page form dialog.
 */
import { ActivityEntityName, ConfigurationSecurityRight, FeatureFlags, SurfaceType, UserType } from '@jms/model';
import type { AgentDefinition } from '@jms/model';
import { CurrentUserService } from '@jms/ui/ui.standalone.services/current.user.service';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

export const extensionAgentManifest = registerManifest<AgentDefinition>({
  entity: ActivityEntityName.Agent,
  featureFlag: FeatureFlags.ExtensionRuntime,
  surfaces: {
    [SurfaceType.WorkflowEditor]: () => import('./surface/workflow.editor/agent.workflow.editor.surface').then(module => module.agentWorkflowEditorSurface),
  },
  operations: {
    edit: {
      surface: SurfaceType.WorkflowEditor,
      presentation: { mode: 'pseudo-page' },
      // Mirrors the server's definition policy: system administrators, or tenant management.
      authorize: ({ injector }) => {

        const role = injector.get(CurrentUserService).$role();
        return role?.type === UserType.SystemAdministrator || !!role?.rights?.includes(ConfigurationSecurityRight.ManageTenancy);
      },
    },
  },
});
